<div class="dialog-container">
  <div mat-dialog-content>
    <h2 class="dialog-title">{{ data?.title || 'Remove user' }}</h2>
    <p *ngIf="data?.message">{{ data?.message }}</p>
    <p><strong>Choose an action:</strong></p>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button class="mat-elevation-z2 rounded-action btn-cancel" (click)="cancel()">Cancel</button>
    <button mat-raised-button class="mat-elevation-z2 rounded-action btn-aker" (click)="unassign()">Unassign user</button>
    <button mat-raised-button class="mat-elevation-z2 rounded-action btn-aker" (click)="deleteNode()">Delete node</button>
  </div>
</div>
